import { createFileRoute } from "@tanstack/react-router";
import { MasterDataPage } from "./-components/MasterDataPage";

export const Route = createFileRoute(
  "/(restricted)/virksomheder/$cvr/stamdata",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <MasterDataPage />;
}
